import $ from 'jquery'
let state = {
    curr_page: 1,
    perPage: 6 // standardized posts_per_page count to reliably use paging
}

function loadMoreposts() {
    const postsListWrapper = $('.blog__posts-wrapper')
    const postsList = $('.blog__posts-grid')

    const curr_page = state.curr_page + 1

    state.curr_page = curr_page

    console.log('curr page: ' + curr_page)
    console.log('state curr page: ' + state.curr_page)

    $.ajax({
        url : php_vars.ajax_url,
        type : 'POST',
        data : {
            curr_page,
            action:'loadmoreposts'
        },
        beforeSend : function(xhr){
            $('.posts__loader').show();
            $('.js-load-more-posts').hide();
        },
        success : function( data ){
            
            var $data = $(data);
            if ($data.length) {
                postsList.append($data);
                $('.posts__loader').hide();
                $data = $data.filter( function() { return this.nodeName == 'LI' } )
                console.log($data.length)
                if(($data.length < state.perPage) || ($data.length === -1)) {
                    $('.js-load-more-posts').hide();
                } else {
                    $('.js-load-more-posts').show();
                }
            } else {
                postsList.append('<h4 class="u-text-center" style="width: 100%">No more articles matching search criteria found!</h4>');
                $('.js-load-more-posts').hide();
                $('.posts__loader').hide();
            }
        },
        error: function(xhr, status, error) {
            var err = eval("(" + xhr.responseText + ")");
            console.log(err.Message);
        }
    })
}


function initposts() {
    $(document).on('click', '.js-load-more-posts', loadMoreposts )
}

initposts()
